import { getContractSASuggestions } from 'app/sponsoredAds/services/autosuggestServices';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';
import withMultiSelectAutosuggest from './withMultiSelectAutosuggest';


const handleApiDataResponse = (res) => {
   return res?.data.map((option = {}) => {
      return ({
         ...option,
         label: `(${ option?.id }) ${ option?.name }`,
      });
   });
};

const ContractAutosuggestSA = autosuggestFactory({
   apiPromise: getContractSASuggestions,
   handleApiDataResponse,
   defaultPlaceholder: 'Search Contract...',
});

export default withAutosuggestWrapper(withInputErrorMessage(ContractAutosuggestSA));
export const ContractMultiSelectSA = withMultiSelectAutosuggest(ContractAutosuggestSA);
